import { ReactElement } from 'react';
import ExerciseTagManagement from '../../../components/exerciseTag/ExerciseTagManagement';

const AdminExerciseTags = (): ReactElement => {
  return (
    <ExerciseTagManagement mode="admin" />
  )
}

export default AdminExerciseTags